import type { Student } from "../../services/studentService";

export const STUDENT_STATUS_LABELS: Record<Student["status"], string> = {
  active: "Active",
  inactive: "Inactive",
  suspended: "Suspended",
  transferred: "Transferred",
  graduated: "Graduated",
  withdrawn: "Withdrawn",
  expelled: "Expelled",
};

export const STUDENT_STATUS_DOTS: Record<string, string> = {
  active: "bg-green-500",
  inactive: "bg-gray-400",
  graduated: "bg-blue-500",
  transferred: "bg-yellow-500",
  suspended: "bg-red-500",
  withdrawn: "bg-gray-400",
  expelled: "bg-red-700",
};

export function studentInitials(student: Student) {
  return `${student.user.first_name?.[0] || "S"}${student.user.last_name?.[0] || "T"}`.toUpperCase();
}

/** The parent marked primary for this learner, else the first one linked. */
export function primaryGuardian(student: Student) {
  const parents = student.parents_data || [];
  const parent =
    parents.find((candidate) => candidate.id === student.primary_parent) ||
    parents.find((candidate) =>
      candidate.children_data?.some(
        (child) => child.id === student.id && child.is_primary,
      ),
    ) ||
    parents[0];
  if (!parent) return null;
  return {
    id: parent.id,
    name:
      parent.full_name ||
      `${parent.user.first_name} ${parent.user.last_name}`.trim(),
    phone: parent.user.phone_number || parent.emergency_contact || "",
    relationship: parent.relationship,
  };
}

/** A YYYY-MM-DD date as the reader writes dates, without a timezone shift. */
export function formatSchoolDate(value?: string | null) {
  if (!value) return "";
  const date = new Date(`${value.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
